// extracted by mini-css-extract-plugin
export default {"root":"StatisticsRow_root_EnvCP","key":"StatisticsRow_key_DcGrV","value":"StatisticsRow_value_w4Bry","color":"StatisticsRow_color_PXmx8"};